import { jsx } from "react/jsx-runtime";
const SvgPayment = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M22 4H2V20H22V4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z", fill: "currentColor" }) });
export default SvgPayment;
